// These strings will be allowed to be passed as ?ref=xxx url parameter for analytics purposes
import { FLOW_TYPE_TO_EVENT_PROP } from 'Douleutaras/constants/job';

export const PRO_PROFILE_REF_SOURCE = {
  SUCCESS_MODAL: 'success_modal'
};

export const ALLOWED_ANALYTICS_REF_GET_PARAMS = [
  'Chat',
  'Professional Settings page', 'Admin page',
  FLOW_TYPE_TO_EVENT_PROP.SINGLE_BID, PRO_PROFILE_REF_SOURCE.SUCCESS_MODAL
];

// Parameters used when fetching profile data from API
export const PROFILE_FETCH_COMMON_GET_PARAMS = {
  'fields[seller-profiles]': 'availablePaymentMethods,sellerDisplayName,mugshot,mugshotVideo,sellerOverviewPublic,concludedJobsCnt,aggregates,sellerRating,' +
    'sellerFeedbacks,memberSince,favoriteCategory,cleanerSettings,isCreditModelSeller,categories,portfolioItems,sellerPortfolio,badges,' +
    'lastUnreviewedBidForUser,concludedJobsCntForUser,autodealCategories,concludedJobsCntForUser,publicUrl,lastConcludedCategoryForUser,seo_settings,subscription_tier,username,municipalities,isSeoEligible'
};
// Models included when fetching profile data from API
export const PROFILE_FETCH_COMMON_INCLUDES = [
  'autodeal_categories',
  'badges',
  'categories',
  'municipalities',
  'portfolio_items',
  'seo_settings'
];

export type ProfileDetailsParams = 'username';
